import { Card as CardAntd } from 'antd';
import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled(CardAntd)`
  border-radius: 12px;
  border-color: ${(props) => {
    return props.color ? props.color : color.grey1;
  }};
  .component_information_card_title {
    display: inline-flex;
    column-gap: 8px;
    align-items: center;
    .anticon {
      font-size: 20px;
      color: ${(props) => {
        return props.color ? props.color : color.grey1;
      }};
    }
  }
`;

export default Wrapper;
